import React from 'react';
import { Tag } from 'antd';
import { FaTruck } from 'react-icons/fa';
import {
    PACKING_ORDER_STATUS,
    TRANSPORT_ORDER_STATUS,
    getPackingStatusColor,
    getLogisticStatusColor,
} from '../../../views/DashboardPackingOrders';

const translateTransportOrderStatus = (status) => {
    const statuses = {
        [TRANSPORT_ORDER_STATUS.TO_BE_PICKED_UP]: 'Por recoger',
        [TRANSPORT_ORDER_STATUS.DISPATCHED]: 'Despachada',
        [TRANSPORT_ORDER_STATUS.IN_TRANSIT]: 'En tránsito',
        [TRANSPORT_ORDER_STATUS.DELIVERED]: 'Entregada',
        [TRANSPORT_ORDER_STATUS.PARTIALLY_DELIVERED]: 'Entrega parcial',
        [TRANSPORT_ORDER_STATUS.DELAYED]: 'Demorada',
        [TRANSPORT_ORDER_STATUS.CANCELED]: 'Cancelada',
        [TRANSPORT_ORDER_STATUS.CLIENT_NOT_IN_ADDRESS]: 'Cliente no se encuentra',
        [TRANSPORT_ORDER_STATUS.SECOND_DELIVERY_ATTEMPT]: 'Segunda vuelta',
        [TRANSPORT_ORDER_STATUS.RETURN_TO_ORIGIN]: 'Retornar a origen',
        [TRANSPORT_ORDER_STATUS.RETURNED_TO_ORIGIN]: 'Devuelta al origen',
    };
    return statuses[status] || status;
};

const translatePackingOrderStatus = (status) => {
    const statuses = {
        [PACKING_ORDER_STATUS.CREATED]: 'Creada',
        [PACKING_ORDER_STATUS.PICKED]: 'Productos recogidos',
        [PACKING_ORDER_STATUS.PACKED]: 'Empaquetada',
        [PACKING_ORDER_STATUS.SHIPPED]: 'Enviada',
        [PACKING_ORDER_STATUS.CANCELED]: 'Cancelada',
        [PACKING_ORDER_STATUS.LABEL_PRINTED]: 'Etiqueta impresa',
    };
    return statuses[status] || status;
};

export default function TransportOrderCard({ item, isSelected = false, onClick }) {
    const { transport_order, packing_order } = item;
    const selectable = typeof onClick === 'function';
    const isActive = transport_order.is_active;
    const isCompleted = transport_order.is_completed;

    const borderColor = isSelected ? '#003eb3' : isCompleted ? '#b7eb8f' : isActive ? '#91caff' : '#d9d9d9';
    const borderWidth = 2;
    const bgColor = isCompleted ? '#f6ffed' : isActive ? '#f0f5ff' : '#fafafa';
    const iconColor = isCompleted ? '#52c41a' : isActive ? '#4096ff' : '#bfbfbf';

    return (
        <div
            onClick={onClick}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '10px 14px',
                borderRadius: 20,
                border: `${borderWidth}px solid ${borderColor}`,
                backgroundColor: bgColor,
                cursor: selectable ? 'pointer' : 'default',
                transition: 'all 0.2s',
            }}
        >
            <FaTruck style={{ fontSize: 22, color: iconColor, flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, color: '#595959' }}>
                    {packing_order?.created_at && new Date(packing_order.created_at).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                </div>
                <div style={{ fontWeight: 700, color: isCompleted ? '#389e0d' : isActive ? '#4096ff' : '#8c8c8c', fontSize: 14 }}>
                    {`OT #${transport_order.id}`}{packing_order?.id && ` · OE #${packing_order.id}`}
                    {packing_order?.point_of_sale_name && ` · ${packing_order.point_of_sale_name}`}
                </div>
                <div style={{ fontSize: 12, color: '#595959', marginTop: 4 }}>
                    <span style={{ fontWeight: 500 }}>Destino:</span> {transport_order.delivery_address}
                </div>
                {packing_order?.delivery_from && (
                    <div style={{ fontSize: 12, color: '#595959', marginTop: 2 }}>
                        <span style={{ fontWeight: 500 }}>Fecha de entrega:</span>{' '}
                        {new Date(packing_order.delivery_from).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        {packing_order.delivery_to && ` - ${new Date(packing_order.delivery_to).toLocaleString('es-AR', { hour: '2-digit', minute: '2-digit' })}`}
                    </div>
                )}
                {isActive && transport_order.delivery_from && (
                    <div style={{ fontSize: 12, color: '#595959', marginTop: 2 }}>
                        <span style={{ fontWeight: 500 }}>Próximo intento:</span>{' '}
                        {new Date(transport_order.delivery_from).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        {transport_order.delivery_to && ` - ${new Date(transport_order.delivery_to).toLocaleString('es-AR', { hour: '2-digit', minute: '2-digit' })}`}
                    </div>
                )}
                <div style={{ fontSize: 12, color: '#595959', marginTop: 2, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    {packing_order && (
                        <>
                            <span style={{ fontWeight: 500 }}>OE:</span>
                            <Tag color={getPackingStatusColor(packing_order.status_id)} style={{ fontWeight: 500, borderRadius: 100, fontSize: 12, color: '#484848', margin: 0 }}>
                                {packing_order.status_id ? translatePackingOrderStatus(packing_order.status_id) : 'Sin estado'}
                            </Tag>
                        </>
                    )}
                    <span style={{ fontWeight: 500 }}>OT:</span>
                    <Tag color={getLogisticStatusColor(transport_order.status?.id)} style={{ fontWeight: 500, borderRadius: 100, fontSize: 12, color: '#484848', margin: 0 }}>
                        {transport_order.status ? translateTransportOrderStatus(transport_order.status.id) : 'Sin estado'}
                    </Tag>
                    {transport_order.driver && (
                        <span style={{ fontSize: 12, color: '#595959', display: 'flex', alignItems: 'center', gap: 4 }}>
                            🚚 {transport_order.driver}
                        </span>
                    )}
                </div>
            </div>
            {selectable && (
                <div
                    style={{
                        width: 16,
                        height: 16,
                        borderRadius: '50%',
                        border: `2px solid ${isSelected ? '#003eb3' : '#d9d9d9'}`,
                        backgroundColor: isSelected ? '#003eb3' : '#fff',
                        flexShrink: 0,
                    }}
                />
            )}
        </div>
    );
}
